// функция получения результата таск из драматик
import axios from "axios";
import {API_DRAMATIQ_TASK_RESULT} from "../service/api.endpoint";

const GetTaskResult = async (requestId: string) => {
    const response: any = await axios.get(API_DRAMATIQ_TASK_RESULT, {params: {requestId: requestId}});
    return response;
}

export default GetTaskResult;